export default "__VITE_ASSET__DKISCZt9__"